import { render, staticRenderFns } from "./EDialogTips.vue?vue&type=template&id=73fdefeb&scoped=true"
import script from "./EDialogTips.vue?vue&type=script&lang=js"
export * from "./EDialogTips.vue?vue&type=script&lang=js"
import style0 from "./EDialogTips.vue?vue&type=style&index=0&id=73fdefeb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fdefeb",
  null
  
)

export default component.exports